
const tabSwitch = () => {
    let hiddenTab = null;
    let visibilityChange = null;
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
        hiddenTab = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hiddenTab = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hiddenTab = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }

    return {
        hiddenTab,
        visibilityChange,
    };
};

export default tabSwitch;



// WEBPACK FOOTER //
// ./src/helpers/tabSwitch.js